// extracted by mini-css-extract-plugin
module.exports = {"buttonGroup":"share-detail-table_buttonGroup_3R2Kr","button":"share-detail-table_button_3nCss"};